export enum SectionFieldType {
  CheckboxInputControl = 1,
  LeftCheckboxControl = 2,
  RightCheckboxControl = 3,
  LabelInputControl = 4,
  DoubleInputControl = 5,
  TextareaControl = 6,
  FieldSetControl = 7,
  ButtonControl = 8,
  DateAtTime = 9,
  LinkControl = 10,
  ClickableLabelInputControl = 11,
  DropdownControl = 12,
  DateInputControl = 13,
  HourHold = 14,
  BorderLabelInputControl = 15,
  None = 16
}
